import api from './api';

// Survey CRUD
export const getSurveys = (params) => api.get('/v1/surveys', { params });
export const getSurvey = (id) => api.get(`/v1/surveys/${id}`);
export const createSurvey = (data) => api.post('/v1/surveys', data);
export const updateSurvey = (id, data) => api.put(`/v1/surveys/${id}`, data);
export const deleteSurvey = (id) => api.delete(`/v1/surveys/${id}`);
export const batchDeleteSurveys = (ids) => api.delete('/v1/surveys', { data: ids });

// Questions
export const addQuestion = (surveyId, data) => api.post(`/v1/surveys/${surveyId}/questions`, data);
export const updateQuestion = (surveyId, questionId, data) => api.put(`/v1/surveys/${surveyId}/questions/${questionId}`, data);
export const deleteQuestion = (surveyId, questionId) => api.delete(`/v1/surveys/${surveyId}/questions/${questionId}`);
export const reorderQuestions = (surveyId, data) => api.put(`/v1/surveys/${surveyId}/questions/reorder`, data);

// Publish / Close
export const publishSurvey = (surveyId, data) => api.post(`/v1/surveys/${surveyId}/publish`, data);
// language: kapanışta otomatik açılan AI taslağının dili (backend arayüz dilini başka yoldan bilmez).
export const closeSurvey = (surveyId, language) => api.put(`/v1/surveys/${surveyId}/close`, null, { params: { language } });

// AI Generate
export const aiGenerateSurvey = (data) => api.post('/v1/surveys/ai-generate', data);

// Participants
export const addParticipants = (surveyId, data) => api.post(`/v1/surveys/${surveyId}/participants`, data);
export const removeParticipant = (surveyId, userId) => api.delete(`/v1/surveys/${surveyId}/participants/${userId}`);

// Results
export const getParticipation = (surveyId, params) => api.get(`/v1/surveys/${surveyId}/results/participation`, { params });
export const exportCsv = (surveyId) => api.get(`/v1/surveys/${surveyId}/results/export`, { responseType: 'blob' });

// My Surveys
export const getMySurveys = () => api.get('/v1/my-surveys');
export const getMySurvey = (id) => api.get(`/v1/my-surveys/${id}`);
export const getMyAnswers = (id) => api.get(`/v1/my-surveys/${id}/answers`);
export const submitSurvey = (id, data) => api.post(`/v1/my-surveys/${id}/submit`, data);

// Public Surveys
export const getPublicSurvey = (token) => api.get(`/v1/public-surveys/${token}`);
export const submitPublicSurvey = (token, data) => api.post(`/v1/public-surveys/${token}/submit`, data);
export const publishPublicSurvey = (surveyId, data) => api.post(`/v1/surveys/${surveyId}/publish-public`, data);
export const getPublicSurveyDashboard = (params) => api.get('/v1/surveys/public-dashboard', { params });
export const getPublicSurveyResults = (surveyId) => api.get(`/v1/surveys/${surveyId}/public-results`);
